import base from "./base"

export default class FormValid {
    idCard = [{
        validator: (rule, code, callback) => {
            let errMsg = base.L("Validate.ErrorIdCardNo");
            if (code == "" || !code) { callback(); return; };
            var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
            var tip = ""
            var pass = true

            if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
                tip = errMsg
                pass = false;
            } else if (!city[code.substr(0, 2)]) {
                tip = errMsg
                pass = false
            } else {
                // 18位身份证需要验证最后一位校验位
                if (code.length === 18) {
                    code = code.split('')
                    // ∑(ai×Wi)(mod 11)
                    // 加权因子
                    var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
                    // 校验位
                    var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
                    var sum = 0
                    var ai = 0
                    var wi = 0
                    for (var i = 0; i < 17; i++) {
                        ai = code[i]
                        wi = factor[i]
                        sum += ai * wi
                    }
                    var last = parity[sum % 11];
                    if (parity[sum % 11] != code[17]) {
                        tip = errMsg
                        pass = false
                    }
                }
            }
            if (!pass) {
                callback(new Error(tip))
            } else {
                callback()
            }
        },
        trigger: "blur"
    }]

    mobile = [{
        validator: (rule, code, callback) => {
            let errMsg = base.L("Validate.ErrorMobile");
            if (code == "" || !code) { callback(); return; };
            let reg = /^1[3|4|5|7|8][0-9]{9}$/;
            if (!reg.test(code)) {
                callback(new Error(errMsg))
            } else {
                callback()
            }
        },
        trigger: "blur"
    }]

    email = [{
        validator: (rule, code, callback) => {
            let errMsg = base.L("Validate.ErrorEmail");
            if (code == "" || !code) { callback(); return; };
            let reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if (!reg.test(code)) {
                callback(new Error(errMsg))
            } else {
                callback()
            }
        },
        trigger: "blur"
    }]

    password = [{
        validator: (rule, code, callback) => {
            let errMsg = base.L("Validate.ErrorPassword");
            if (code == "" || !code) { callback(); return; };
            // let reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;   必须包含大小写数字
            let reg = /^(?=.*\d)(?=.*[a-zA-Z]).{6,20}$/;   //必须包含字母数字
            if (!reg.test(code)) {
                callback(new Error(errMsg))
            } else {
                callback()
            }
        },
        trigger: "blur"
    }]
}
